import React from "react";
import "./panchangam.css";
import { Box, Typography } from "@mui/material";
import TitleBox from "../../../../components/common/titleBox/TitleBox";

function PanchangamDt(props) {
  const { dailyPanchangam } = props;

  return (
    <TitleBox
      title={<Box class="panchang-title">
                <Typography variant="h6" component="div">
                  Panchang
                </Typography>
              </Box>}
      buttonLabel={"Full Panchang"}
      buttonLink={"/fullpanchang"}
      subcontent={
        <div className="sub-title-bg d-flex justify-content-center align-items-center">
          <h2>
            {new Date().toLocaleDateString("en-US", {
              timeZone: "America/New_York",
              weekday: "long",
              month: "long",
              day: "numeric",
              year: "numeric",
            })}
          </h2>
        </div>
      }
      content={
        <>
          <div className="panchang-content1">
            <React.Fragment>
              <div className="text-centerpt-0 panchang">
                {/* <div className="title-bg">
                      <h2>Panchangam</h2>
                    </div> 
                */}
                <div className="panchang-content2">
                  <div className="panchagan-table">
                    <iframe
                      id="IDpanchang"
                      src="https://www.mypanchang.com/newsite/compactfeed.php?locid=4758023&mode=full&pt=12pt"
                      width="100%"
                      height="100%"
                      frameBorder="0"
                      scrolling="auto"
                    ></iframe>
                  </div>
                </div>
              </div>
            </React.Fragment>
          </div>
        </>
      }
    />
  );
}
export default PanchangamDt;
